import { IModuleStateProps, withModuleState } from '@msdyn365-commerce-modules/checkout-utilities';
import { getRichTextHtml } from '@msdyn365-commerce/core';
import { computed, when } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import Input from 'reactstrap/lib/Input';
import { ISmweCheckoutTermsAndConditionsData } from './smwe-checkout-terms-and-conditions.data';
import { ISmweCheckoutTermsAndConditionsProps } from './smwe-checkout-terms-and-conditions.props.autogenerated';

interface ICheckoutTermsAndConditionsState {
    accepted: boolean;
    submitted: boolean;
}

interface IProps extends ISmweCheckoutTermsAndConditionsProps<ISmweCheckoutTermsAndConditionsData>, IModuleStateProps { }

/**
 * Checkout Terms and Conditions
 */
// @ts-ignore
@withModuleState
@observer
class CheckoutTermsAndConditions extends React.Component<IProps> {
    public state: ICheckoutTermsAndConditionsState = {
        accepted: false,
        submitted: false
    };

    @computed get isDataReady(): boolean {
        return (
            (this.props.data.checkoutState && this.props.data.checkoutState.result && this.props.data.checkoutState.status) === 'SUCCESS'
        );
    }

    public componentDidMount(): void {
        // @ts-ignore: Compiler not reconizing condition check for function params
        when(
            () => this.isDataReady,
            () => {
                this.init();
            }
        );
        }

    public render(): JSX.Element | null {
        return (
            <div className='checkout-terms-and-conditions'>
                <label>
                    <Input
                        checked={this.state.accepted}
                        disabled={this.state.submitted}
                        type='checkbox'
                        onChange={this.onChange}
                    />
                    {this.props.config.conditions && // tslint:disable-next-line:react-no-dangerous-html
                         <span dangerouslySetInnerHTML={getRichTextHtml(this.props.config.conditions)} />}
                </label>
                <div className='row'>
                <span className='col-2 msc-p65-warning-icon'>{this._prop65Icon}</span>
                {this.props.config.prop65WarningText && // tslint:disable-next-line:react-no-dangerous-html
                    <span className='col-10 msc-p65-warning-text' dangerouslySetInnerHTML={getRichTextHtml(this.props.config.prop65WarningText)} />}
                {this.props.config.legalDisclaimer && // tslint:disable-next-line:react-no-dangerous-html
                    <span className='col-10 col-offset-2 msc-p65-warning-text' dangerouslySetInnerHTML={getRichTextHtml(this.props.config.legalDisclaimer)} />}
                </div>
            </div>
        );
    }

    private init = (): void => {
        const accepted = this.state.accepted;
        this.props.moduleState.init({
            status: (accepted ? 'ready' : 'updating')
        });
    };

    private onSubmit = (): void => {
        const { accepted } = this.state;
        if (!accepted) {
            this.props.moduleState.setHasError(true);
        } else {
            this.props.moduleState.onReady();
            this.setState({submitted: true});
        }
    };

    private onChange = (checkbox: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({accepted: checkbox.target.checked}, () => {
            this.onSubmit();
        });
    };

    private get _prop65Icon(): JSX.Element | null {
        const {
            prop65Icon,
        } = this.props.config;

        if (prop65Icon) {
            return <img src={prop65Icon.src} alt='Prop 65 Icon'/>;
        }

        return null;
    }
}

export default CheckoutTermsAndConditions;